import  {eXcell,__extends} from './eXcell';
import {dhx4} from '../../global/dhx4OrDhx';

var eXcell_ed = (function (_super) {
    __extends(eXcell_ed, _super);
    function eXcell_ed(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
    }
    eXcell_ed.prototype.edit = function () {
        this.cell.atag = !this.grid.multiLine ? "INPUT" : "TEXTAREA";
        this.val = this.getValue();
        this.obj = document.createElement(this.cell.atag);
        this.obj.setAttribute("autocomplete", "off");
        this.obj.style.height =
            this.cell.offsetHeight - (this.grid.multiLine ? 9 : 4) + "px";
        this.obj.className = "dhx_combo_edit";
        this.obj.wrap = "soft";
        this.obj.style.textAlign = this.cell.style.textAlign;
        this.obj.onclick = function (c) {
            (c || event).cancelBubble = true;
        };
        this.obj.onmousedown = function (c) {
            (c || event).cancelBubble = true;
        };
        this.obj.value = this.val;
        this.cell.innerHTML = "";
        this.cell.appendChild(this.obj);
        this.obj.onselectstart = function (c) {
            if (!c) {
                c = event;
            }
            c.cancelBubble = true;
            return true;
        };
        if (dhx4.isIE) {
            this.obj.focus();
            this.obj.blur();
        }
        this.obj.focus();
    };
    eXcell_ed.prototype.getValue = function () {
        if (this.cell.firstChild &&
            (this.cell.atag && this.cell.firstChild.tagName == this.cell.atag)) {
            return this.cell.firstChild.value;
        }
        if (this.cell._clearCell) {
            return "";
        }
        return this.cell.innerText.toString()._dhx_trim();
    };
    eXcell_ed.prototype.detach = function () {
        this.setValue(this.obj.value);
        return this.val != this.getValue();
    };
    return eXcell_ed;
})(eXcell);
window.eXcell_ed = eXcell_ed;

export default eXcell_ed;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_ed.js